const data = {
  unicPay: 'Pago único',
  mothPay: 'Pago a meses',
  card: {
    titleCard: 'Tarjeta de crédito o débito',
    titleCardMonth: 'Tarjeta de crédito',
    secured: 'Pago seguro con encriptación SSL',
    policyCard: 'Conoce nuestra política de reembolso',
  },
  oxxo: {
    titleOxxo: 'Pago en efectivo',
    descriptionOxxo:
      'Utiliza tu referencia de pago para realizar tu pago en OXXO',
    stepsOxxo: [
      'Obtén tu referencia de pago',
      'Ve a cualquier sucursal OXXO e indica al cajero que deseas realizar el pago a través de un número de referencia  o muestra el código de barras',
      'Realiza tu pago y obtén la confirmación al instante',
    ],
    buttonOxxo: 'Obtener referencia de pago',
    policyOxxo: 'Conoce nuestra política de reembolso',
  },
  spei: {
    titleSpei: 'Transferencia interbancaria',
    descriptionSpei: 'Realiza el pago de tu pedido desde tu banca en línea',
    stepsSpei: [
      'Ingresa a tu banca en línea',
      'Utiliza la CLABE interbancaria para realizar la transferencia con el concepto especificado',
      'Una vez realizado tu pago, este tardará de 48 a 72 horas en reflejarse. Te enviaremos un email una vez esto suceda',
    ],
    buttonSpei: 'Obtener CLABE interbancaria',
    policySpei: 'Conoce nuestra política de reembolso',
  },
  atrato: {
    titleAtrato: 'Paga a meses sin tener tarjeta',
    descriptionAtrato:
      '¡Ya casi tendrás tu compra!, para obtener tu producto es necesario que completes el proceso de solicitud de crédito con Atrato.',
    buttonAtrato: 'Continuar con Atrato',
    policyAtrato: 'Conoce nuestra política de reembolso',
  },
};

export default data;
